var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfusion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_2019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5931 7.41066C10.5931 9.14763 10.6174 12.6216 10.5931 14.0063C10.6053 14.2857 10.5324 14.8262 10.2955 15.142C9.95543 15.6036 9.15983 15.5368 9.06873 15.5307H2.51561C1.67142 15.5307 0.991211 14.8505 0.991211 14.0063V4.00353C0.991211 3.15934 1.67142 2.47913 2.51561 2.47913H9.06873C9.91292 2.47913 10.5931 3.15934 10.5931 4.00353",
    stroke: "#572580",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.11865 9.20224C1.81101 9.10507 2.86777 9.01397 4.14317 9.14758C5.12704 9.25083 5.63113 9.42695 6.51784 9.59093C7.42883 9.75491 8.76496 9.91889 10.4837 9.81564",
    stroke: "#572580",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41235 4.7384H4.1311",
    stroke: "#572580",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41235 6.43896H3.37194",
    stroke: "#572580",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 11.6984C14.0002 10.5566 14.9416 9.62134 16.0773 9.62134C17.213 9.62134 18.1544 10.5627 18.1544 11.6984V16.4781",
    stroke: "#572580",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9961 11.9839C11.9961 9.75495 13.8302 7.92688 16.0531 7.92688C18.2759 7.92688 20.11 9.76102 20.11 11.9839L20.1343 16.4781",
    stroke: "#572580",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87622 16.636C6.87622 17.7778 8.03015 18.713 9.43916 18.713C10.8482 18.713 12.0021 17.7717 12.0021 16.636V12.3361",
    stroke: "#572580",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7749 16.9518C4.7749 19.1807 6.83376 21.0088 9.34204 21.0088C11.8503 21.0088 13.9092 19.1746 13.9092 16.9518L14.0064 11.9474",
    stroke: "#572580",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7749 16.9944V16.0409",
    stroke: "#572580",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87622 16.6361V16.0409",
    stroke: "#572580",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6263 17.2677H17.7354V19.4359H20.6263V17.2677Z",
    stroke: "#572580",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14945 0.991211H4.25854V2.47917H7.14945V0.991211Z",
    stroke: "#572580",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_2019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2424,
    height: 20.625,
    fill: "white",
    transform: "translate(0.6875 0.6875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfusion);
export default __webpack_public_path__ + "static/media/infusion.146567afdb85e45c0d9347efebe252e3.svg";
export { ForwardRef as ReactComponent };